var map = {
	"./1-detail.jpg": 866,
	"./2-detail.jpg": 867,
	"./4-detail.jpg": 868,
	"./6-detail.jpg": 869,
	"./7-detail.jpg": 870,
	"./Thinkpad_X1_Carbon_Premium_LCD_closeup_sh02.jpg": 871,
	"./Yoga_002.jpg": 872,
	"./about-service/img_2.jpg": 873,
	"./about/Izobrazhenie_3.jpg": 874,
	"./about/Izobrazhenie_4_2.jpg": 875,
	"./about/about-photo-1.jpg": 876,
	"./about/about-photo-2.jpg": 877,
	"./about/about-photo-3.jpg": 878,
	"./about/about-photo-4.jpg": 879,
	"./about/about-photo-5.jpg": 880,
	"./about/about-photo-6.jpg": 881,
	"./about/about-photo-7.jpg": 882,
	"./about/about-photo-8.jpg": 883,
	"./about/about-photo-9.jpg": 884,
	"./about/about-promo-bg-900-599.jpg": 885,
	"./about/about-promo-bg.jpg": 886,
	"./alfa-direkt-1.jpg": 887,
	"./author-1.jpg": 888,
	"./author-1@2x.jpg": 889,
	"./author-2.jpg": 890,
	"./author-2@2x.jpg": 891,
	"./author-3.jpg": 892,
	"./author-3@2x.jpg": 893,
	"./author-4.jpg": 894,
	"./author-4@2x.jpg": 895,
	"./author-5.jpg": 896,
	"./author-5@2x.jpg": 897,
	"./author-6.jpg": 898,
	"./author-6@2x.jpg": 899,
	"./bg-promo-three-mobile.jpg": 900,
	"./bg-promo-three-mobile@2x.jpg": 901,
	"./bg-promo-three.jpg": 902,
	"./bg-promo-three@2x.jpg": 903,
	"./bill/product-detail-marketing-promo-bg-mobile.jpg": 529,
	"./bill/product-detail-marketing-promo-bg.jpg": 528,
	"./bittner-pharma-1.jpg": 904,
	"./brochure-promo-bg.jpg": 905,
	"./brochure/avatar-1.jpg": 906,
	"./brochure/avatar-2.jpg": 907,
	"./brochure/avatar-3.jpg": 908,
	"./brochure/avatar-4.jpg": 909,
	"./brochure/avatar-5.jpg": 910,
	"./brochure/brochure-promo-bg.jpg": 911,
	"./categories/skin-1.jpg": 611,
	"./categories/skin-2.jpg": 610,
	"./categories/skin-4.jpg": 614,
	"./categories/skin-5.jpg": 616,
	"./categories/skin-6.jpg": 618,
	"./categories/skin-7.jpg": 619,
	"./categories/skin-8.jpg": 607,
	"./choose-platform/brochure-promo-bg.jpg": 912,
	"./clients-items/alfa_bank/alfa-bank-1.jpg": 570,
	"./clients-items/amplua_broker/amplua-broker-bg.jpg": 571,
	"./clients-items/bittner_farma/bittner-farma-1.jpg": 572,
	"./clients-items/completo/completo-bg.jpg": 573,
	"./clients-items/completo/completo-review-avatar.jpg": 472,
	"./clients-items/faberlic/faberlic-bg.jpg": 575,
	"./clients-items/fokus_media/fokus-media-1.jpg": 913,
	"./clients-items/foodik/foodik-bg.jpg": 576,
	"./clients-items/ilearney/ilearney-1.jpg": 914,
	"./clients-items/lenovo/lenovo-bg-content-3.jpg": 915,
	"./clients-items/lenovo/lenovo-bg.jpg": 916,
	"./clients-items/lenovo/lenovo-review-avatar.jpg": 917,
	"./clients-items/mgu/mgu-1.jpg": 579,
	"./clients-items/mgu/mgu-bg.jpg": 577,
	"./clients-items/mgu/mgu-review-avatar.jpg": 507,
	"./clients-items/mgu/mgu-video-poster.jpg": 578,
	"./clients-items/midea/midea-1.jpg": 581,
	"./clients-items/midea/midea-bg.jpg": 580,
	"./clients-items/qiwi/qiwi-bg.jpg": 918,
	"./clients-items/review-bg.jpg": 497,
	"./clients-items/rudn/rudn-1.jpg": 582,
	"./clients-items/see-also/fokus-media-skin.jpg": 495,
	"./clients-items/see-also/ilearney-logo.jpg": 510,
	"./clients-items/see-also/ilearney-skin.jpg": 509,
	"./clients-items/see-also/lenovo-skin.jpg": 496,
	"./clients-items/see-also/rudn-skin.jpg": 919,
	"./clients-items/siemens/siemens-bg.jpg": 583,
	"./completo/skin-detail-completo-promo.jpg": 920,
	"./completo/skin-detail-completo-review-avatar.jpg": 921,
	"./completo/skin-detail-completo-video-poster.jpg": 574,
	"./completo/skin-detail-msu-video-poster.jpg": 922,
	"./contacts/contacts--promo.jpg": 602,
	"./contacts/contacts-photo.jpg": 923,
	"./contacts/product-detail-promo-bg.jpg": 924,
	"./content-page-promo-bg.jpg": 473,
	"./content/content-page-promo-bg.jpg": 925,
	"./content/content-photo.jpg": 926,
	"./control-1-760.jpg": 927,
	"./control-1.jpg": 928,
	"./control-1@2x.jpg": 929,
	"./control-3-760.jpg": 930,
	"./control-3.jpg": 931,
	"./control-3@2x.jpg": 932,
	"./control-4-760.jpg": 933,
	"./control-4.jpg": 934,
	"./control-4@2x.jpg": 935,
	"./director-speech/director-speech-bg.jpg": 936,
	"./efficiency-mark-2.jpg": 937,
	"./efficiency-mark-2@2x.jpg": 938,
	"./faq_and_support/support.jpg": 603,
	"./faq_and_support/support_2x.jpg": 939,
	"./forum-madia-1.jpg": 940,
	"./functions/for-learning/data-handling-screen-1.jpg": 941,
	"./functions/for-learning/data-handling-screen-2.jpg": 942,
	"./functions/for-learning/easy-learn-photo.jpg": 943,
	"./functions/for-learning/fast-start-photo.jpg": 944,
	"./functions/for-learning/planning-screen.jpg": 945,
	"./functions/for-learning/product-detail-promo-bg.jpg": 946,
	"./functions/for-marketing/landings-bg.jpg": 947,
	"./functions/for-marketing/landings-screen-2.jpg": 948,
	"./functions/for-marketing/landings.jpg": 949,
	"./functions/for-marketing/payments-screen-12.jpg": 950,
	"./functions/for-marketing/payments-screen-13.jpg": 951,
	"./functions/for-marketing/product-detail-marketing-promo-bg.jpg": 535,
	"./functions/for-marketing/statistic-screen-1.jpg": 952,
	"./functions/for-marketing/statistic-screen-2.jpg": 953,
	"./functions/for-marketing/video-editor-bg.jpg": 954,
	"./functions/for-meetings/product-detail-meeting-promo-bg.jpg": 955,
	"./functions/for-meetings/statistic-screen-3.jpg": 956,
	"./functions/for-meetings/statistic-screen-4.jpg": 957,
	"./functions/for-meetings/statistic-screen-5.jpg": 958,
	"./functions/product-detail-broadcasting-bg.jpg": 565,
	"./functions/product-detail-promo-bg-900-591.jpg": 637,
	"./functions/product-detail-promo-bg.jpg": 502,
	"./gos-bg-mobile.jpg": 959,
	"./gos-bg.jpg": 960,
	"./ilearney-1.jpg": 961,
	"./industry-healthcare/form-image.jpg": 962,
	"./industry-healthcare/image.jpg": 963,
	"./industry-healthcare/image_mobile.jpg": 964,
	"./industry-healthcare/promo.jpg": 965,
	"./industry-healthcare/promo_mobile.jpg": 966,
	"./industry-healthcare/promo_tablet.jpg": 967,
	"./interface/apple.jpg": 968,
	"./interface/interface-screen-1.jpg": 969,
	"./interface/interface-screen-10.jpg": 970,
	"./interface/interface-screen-11.jpg": 971,
	"./interface/interface-screen-12.jpg": 972,
	"./interface/interface-screen-13.jpg": 973,
	"./interface/interface-screen-14.jpg": 974,
	"./interface/interface-screen-2.jpg": 975,
	"./interface/interface-screen-3.jpg": 976,
	"./interface/interface-screen-4.jpg": 977,
	"./interface/interface-screen-5.jpg": 604,
	"./interface/interface-screen-6.jpg": 605,
	"./interface/interface-screen-7.jpg": 606,
	"./interface/interface-screen-8.jpg": 978,
	"./interface/interface-screen-9.jpg": 979,
	"./logo-ilearney.jpg": 980,
	"./logo/UhMbtVsiemens2.jpg": 981,
	"./logo/amplua.jpg": 982,
	"./logo/completo.jpg": 983,
	"./logo/faberlic.jpg": 984,
	"./logo/it_2.jpg": 985,
	"./logo/logo-amplua.jpg": 617,
	"./logo/logo-bittner-farma.jpg": 612,
	"./logo/logo-completo.jpg": 620,
	"./logo/logo-faberlic.jpg": 613,
	"./logo/logo-ilearney.jpg": 615,
	"./logo/logo-platezhnye-sistemy-qiwi.jpg": 986,
	"./logo/logo-qiwi.jpg": 608,
	"./logo/logo-siemens.jpg": 609,
	"./main/main--reviews/reviews-author-1.jpg": 987,
	"./main/main--reviews/reviews-author-2.jpg": 988,
	"./main/main--reviews/reviews-author-3.jpg": 989,
	"./meetings-skype/author-review.jpg": 990,
	"./meetings-zoom/author-review.jpg": 991,
	"./midea-bg.jpg": 992,
	"./midea-img1.jpg": 993,
	"./multilingualism.jpg": 994,
	"./multilingualism@2x.jpg": 995,
	"./online-learning-1.jpg": 996,
	"./online-learning-1@2x.jpg": 997,
	"./online-learning-3.jpg": 998,
	"./online-learning-3@2x.jpg": 999,
	"./online-learning-4.jpg": 1000,
	"./online-learning-4@2x.jpg": 1001,
	"./paralax-content-mobile.jpg": 1002,
	"./paralax-content.jpg": 1003,
	"./partners-bg.jpg": 1004,
	"./partners/contacts_mobile.jpg": 636,
	"./partners/contacts_tablet.jpg": 634,
	"./partners/promo_desktop.jpg": 633,
	"./partners/promo_mobile.jpg": 635,
	"./personaldemo/event-1.jpg": 1005,
	"./platform.jpg": 1006,
	"./platform/platform.jpg": 1007,
	"./platform/platform@2x.jpg": 1008,
	"./platform@2x.jpg": 1009,
	"./price.jpg": 1010,
	"./product-detail-promo-bg.jpg": 1011,
	"./product-detail/product-detail-marketing-promo-bg.jpg": 1012,
	"./product-detail/product-detail-promo-bg.jpg": 1013,
	"./products-comdi/capability-img_1.jpg": 751,
	"./products-comdi/capability-img_2.jpg": 752,
	"./products-comdi/capability-img_3.jpg": 753,
	"./products-comdi/capability-slider-img_1--mobile.jpg": 638,
	"./products-comdi/capability-slider-img_1.jpg": 754,
	"./products-comdi/capability-slider-img_2--mobile.jpg": 639,
	"./products-comdi/capability-slider-img_2.jpg": 755,
	"./products-comdi/capability-slider-img_3--mobile.jpg": 640,
	"./products-comdi/capability-slider-img_3.jpg": 756,
	"./products-comdi/form-img.jpg": 641,
	"./products-comdi/img_bg.jpg": 552,
	"./products-comdi/organization-img_2--mobile.jpg": 642,
	"./products-comdi/organization-img_2--tablet.jpg": 757,
	"./products-comdi/organization-img_2.jpg": 758,
	"./products-meetings/meetings--detail/1.jpg": 1014,
	"./products-meetings/meetings--detail/2.jpg": 1015,
	"./products-meetings/meetings--detail/3.jpg": 1016,
	"./products-meetings/meetings--detail/4.jpg": 1017,
	"./products-meetings/meetings--exp/anatoly_volkov.jpg": 759,
	"./products-meetings/meetings--exp/andrey_zhirkov.jpg": 760,
	"./products-meetings/meetings--exp/dmitry_starostov.jpg": 761,
	"./products-meetings/meetings--exp/reviews/author-1.jpg": 762,
	"./products-meetings/meetings--exp/reviews/author-2.jpg": 763,
	"./products-meetings/meetings--exp/reviews/author-3.jpg": 764,
	"./products-meetings/meetings--expand/boards.jpg": 643,
	"./products-meetings/meetings--form/form.jpg": 765,
	"./products-meetings/meetings--form/form_768.jpg": 766,
	"./products-meetings/meetings--form/form_992.jpg": 767,
	"./products-meetings/meetings--high-level/ai.jpg": 644,
	"./products-meetings/meetings--high-level/platform.jpg": 645,
	"./products-meetings/meetings--high-level/slider/1.jpg": 768,
	"./products-meetings/meetings--high-level/slider/2.jpg": 769,
	"./products-meetings/meetings--high-level/slider/3.jpg": 770,
	"./products-meetings/meetings--high-level/slider/4.jpg": 771,
	"./products-meetings/meetings--request-rooms/rooms_1.jpg": 1018,
	"./products-meetings/meetings--request-rooms/rooms_2.jpg": 1019,
	"./products-meetings/meetings--request-rooms/rooms_3.jpg": 1020,
	"./products-meetings/meetings--request-rooms/rooms_4.jpg": 1021,
	"./products-meetings/meetings--tariffs/tariff.jpg": 646,
	"./products-meetings/meetings--tariffs/tariff_375.jpg": 772,
	"./products-meetings/meetings--top/1440_top.jpg": 773,
	"./products-meetings/meetings--top/375_top.jpg": 774,
	"./products-meetings/meetings--top/768_top.jpg": 775,
	"./products-messenger/cases/author_chernogolovka.jpg": 776,
	"./products-messenger/cases/author_kantiana.jpg": 777,
	"./products-messenger/tariffs_card_1.jpg": 647,
	"./products-messenger/tariffs_card_2.jpg": 648,
	"./products-messenger/tariffs_card_2_mobile.jpg": 778,
	"./products-on-premise/case-1-mobile.jpg": 649,
	"./products-on-premise/case-1-tablet.jpg": 650,
	"./products-on-premise/case-1.jpg": 651,
	"./products-on-premise/image_1.jpg": 652,
	"./products-on-premise/image_1_mobile.jpg": 653,
	"./products-on-premise/image_1_tablet.jpg": 654,
	"./products-on-premise/image_3.jpg": 655,
	"./products-on-premise/slide_control.jpg": 656,
	"./products-on-premise/slide_groups.jpg": 657,
	"./products-on-premise/slide_logging.jpg": 658,
	"./products-on-premise/slide_waiting-room.jpg": 659,
	"./products-rooms/for_who_1.jpg": 660,
	"./products-rooms/for_who_1_mobile.jpg": 661,
	"./products-rooms/for_who_1_tablet.jpg": 662,
	"./products-rooms/for_who_2.jpg": 663,
	"./products-rooms/for_who_2_mobile.jpg": 664,
	"./products-rooms/for_who_2_tablet.jpg": 665,
	"./products-rooms/for_who_3.jpg": 666,
	"./products-rooms/for_who_3_mobile.jpg": 667,
	"./products-rooms/for_who_3_tablet.jpg": 668,
	"./products-rooms/image_2.jpg": 669,
	"./products-rooms/image_2_mobile.jpg": 670,
	"./products-rooms/image_2_tablet.jpg": 671,
	"./products-rooms/image_3.jpg": 672,
	"./products-rooms/image_3_mobile.jpg": 673,
	"./products-rooms/image_3_tablet.jpg": 674,
	"./products-rooms/image_4.jpg": 675,
	"./products-rooms/photo_1.jpg": 676,
	"./products-rooms/photo_2.jpg": 677,
	"./products-rooms/photo_3.jpg": 678,
	"./products-rooms/photo_4.jpg": 679,
	"./products-rooms/video.jpg": 1022,
	"./products-webinars/cases/cases-author-1.jpg": 1023,
	"./products-webinars/cases/cases-author-2.jpg": 1024,
	"./products-webinars/cases/cases-author-3.jpg": 1025,
	"./products-webinars/cases/cases-author-4.jpg": 1026,
	"./products-webinars/cases/cases-author-5.jpg": 1027,
	"./products-webinars/cases/cases-author-6.jpg": 1028,
	"./products-webinars/cases/cases-logo-1.jpg": 1029,
	"./products-webinars/cases/cases-logo-2.jpg": 1030,
	"./products-webinars/cases/cases-logo-3.jpg": 1031,
	"./products-webinars/cases/cases-logo-4.jpg": 1032,
	"./products-webinars/cases/cases-logo-5.jpg": 1033,
	"./products-webinars/cases/cases-logo-6.jpg": 1034,
	"./products-webinars/devices_1_1920.jpg": 1035,
	"./products-webinars/devices_1_375.jpg": 1036,
	"./products-webinars/devices_1_768.jpg": 1037,
	"./products-webinars/devices_2_1920.jpg": 1038,
	"./products-webinars/devices_2_375.jpg": 1039,
	"./products-webinars/devices_2_768.jpg": 1040,
	"./products-webinars/link-on-premise-bg_1920.jpg": 1041,
	"./products-webinars/link-on-premise-bg_375.jpg": 1042,
	"./products-webinars/link-on-premise-bg_768.jpg": 1043,
	"./products-webinars/webinars--detail/1.1.jpg": 1044,
	"./products-webinars/webinars--detail/1.2.jpg": 1045,
	"./products-webinars/webinars--detail/1.3.jpg": 1046,
	"./products-webinars/webinars--detail/2.1.jpg": 1047,
	"./products-webinars/webinars--detail/2.2.jpg": 1048,
	"./products-webinars/webinars--detail/2.3.jpg": 1049,
	"./products-webinars/webinars--detail/3.1.jpg": 1050,
	"./products-webinars/webinars--detail/3.2.jpg": 1051,
	"./products-webinars/webinars--detail/3.3.jpg": 1052,
	"./products-webinars/webinars--detail/4.1.jpg": 1053,
	"./products-webinars/webinars--detail/4.2.jpg": 1054,
	"./products-webinars/webinars--detail/4.3.jpg": 1055,
	"./products-webinars/webinars--exp/reviews/author-1.jpg": 1056,
	"./products-webinars/webinars--exp/reviews/author-2.jpg": 1057,
	"./products-webinars/webinars--exp/reviews/author-3.jpg": 1058,
	"./products-webinars/webinars--expand/1440 kurs.jpg": 680,
	"./products-webinars/webinars--form/992_form.jpg": 779,
	"./products-webinars/webinars--form/form_desktop.jpg": 780,
	"./products-webinars/webinars--form/form_mobile.jpg": 781,
	"./products-webinars/webinars--media/1.jpg": 1059,
	"./products-webinars/webinars--tariffs/1440_tarif.jpg": 782,
	"./products-webinars/webinars--tariffs/375 tarif.jpg": 783,
	"./products-webinars/webinars--tariffs/768_tarif.jpg": 784,
	"./products-webinars/webinars--top/1440_top.jpg": 785,
	"./products-webinars/webinars--top/768_top.jpg": 786,
	"./products-webinars/webinars-form__1920.jpg": 1060,
	"./products-webinars/webinars_1_1920.jpg": 1061,
	"./products-webinars/webinars_1_375.jpg": 1062,
	"./products-webinars/webinars_1_768.jpg": 1063,
	"./products-webinars/webinars_2_1920.jpg": 1064,
	"./products-webinars/webinars_2_375.jpg": 1065,
	"./products-webinars/webinars_3_1920.jpg": 1066,
	"./products-webinars/webinars_3_375.jpg": 1067,
	"./products-webinars/webinars_6_1920.jpg": 1068,
	"./products-webinars/webinars_6_375.jpg": 1069,
	"./products-webinars/webinars_7_1920.jpg": 1070,
	"./products-webinars/webinars_7_375.jpg": 1071,
	"./products-webinars/webinars_7_768.jpg": 1072,
	"./products-westudy/form_image.jpg": 787,
	"./products-westudy/form_image_mobile.jpg": 788,
	"./products-westudy/form_image_tablet.jpg": 789,
	"./products-westudy/head.jpg": 790,
	"./products-westudy/head_mobile.jpg": 791,
	"./products-westudy/head_tablet.jpg": 792,
	"./products-westudy/image_1.jpg": 793,
	"./products-westudy/image_1_mobile.jpg": 794,
	"./products-westudy/image_1_tablet.jpg": 795,
	"./products-westudy/image_2.jpg": 796,
	"./products-westudy/image_2_mobile.jpg": 797,
	"./products-westudy/image_2_tablet.jpg": 798,
	"./products-westudy/involvement_1.jpg": 799,
	"./products-westudy/involvement_1_mobile.jpg": 800,
	"./products-westudy/involvement_1_tablet.jpg": 801,
	"./products-westudy/involvement_2.jpg": 802,
	"./products-westudy/involvement_2_mobile.jpg": 803,
	"./products-westudy/involvement_2_tablet.jpg": 804,
	"./products-westudy/involvement_3.jpg": 805,
	"./products-westudy/involvement_3_mobile.jpg": 806,
	"./products-westudy/involvement_3_tablet.jpg": 807,
	"./products-westudy/paperwork_1.jpg": 808,
	"./products-westudy/paperwork_1_mobile.jpg": 809,
	"./products-westudy/paperwork_1_tablet.jpg": 810,
	"./products-westudy/paperwork_2.jpg": 811,
	"./products-westudy/paperwork_2_mobile.jpg": 812,
	"./products-westudy/paperwork_2_tablet.jpg": 813,
	"./products-westudy/paperwork_3.jpg": 814,
	"./products-westudy/paperwork_3_mobile.jpg": 815,
	"./products-westudy/paperwork_3_tablet.jpg": 816,
	"./products-westudy/platform_1.jpg": 817,
	"./products-westudy/platform_1_mobile.jpg": 818,
	"./products-westudy/platform_1_tablet.jpg": 819,
	"./products-westudy/platform_2.jpg": 820,
	"./products-westudy/platform_2_mobile.jpg": 821,
	"./products-westudy/platform_2_tablet.jpg": 822,
	"./products-westudy/platform_3.jpg": 823,
	"./products-westudy/platform_3_mobile.jpg": 824,
	"./products-westudy/platform_3_tablet.jpg": 825,
	"./registration-1.jpg": 1073,
	"./registration-1@2x.jpg": 1074,
	"./registration-2.jpg": 1075,
	"./registration-2@2x.jpg": 1076,
	"./registration-3-test.jpg": 1077,
	"./registration-3.jpg": 1078,
	"./registration-3@2x.jpg": 1079,
	"./registration-4.jpg": 1080,
	"./registration-4@2x.jpg": 1081,
	"./registration-5.jpg": 1082,
	"./registration-5@2x.jpg": 1083,
	"./registration-6.jpg": 1084,
	"./registration-6@2x.jpg": 1085,
	"./reviews-author-11.jpg": 1086,
	"./reviews-author-11@2x.jpg": 1087,
	"./reviews-author-12.jpg": 1088,
	"./reviews-author-12@2x.jpg": 1089,
	"./reviews-author-13.jpg": 1090,
	"./reviews-author-13@2x.jpg": 1091,
	"./reviews-author-14.jpg": 1092,
	"./reviews-author-14@2x.jpg": 1093,
	"./reviews-author-15.jpg": 1094,
	"./reviews-author-16.jpg": 1095,
	"./reviews-author-17.jpg": 1096,
	"./reviews/review-photo-1.jpg": 566,
	"./reviews/review-photo-2.jpg": 1097,
	"./rudn-1.jpg": 1098,
	"./signup/signup-background.jpg": 230,
	"./skin-detail-completo-promo.jpg": 1099,
	"./skin-detail-completo-review-avatar.jpg": 1100,
	"./skin-detail-completo-video-poster.jpg": 1101,
	"./skin-detail-msu-review-avatar.jpg": 1102,
	"./skin-detail-msu-spec-block.jpg": 1103,
	"./skin-detail-msu-video-poster.jpg": 1104,
	"./skin-detail-promo-msu.jpg": 1105,
	"./skin-detail-review-bg.jpg": 1106,
	"./skin-detail-use-functions-bg.jpg": 1107,
	"./skin-fokus-media.jpg": 1108,
	"./skin-ilearney.jpg": 1109,
	"./skin-rudn.jpg": 1110,
	"./support-promo-bg-900-599.jpg": 632,
	"./support-promo-bg.jpg": 631,
	"./tariffs/product-detail-promo-bg.jpg": 553,
	"./task/common-healthcare/background_gradient.jpg": 498,
	"./task/common-healthcare/background_gradient_mobile.jpg": 1111,
	"./task/common-healthcare/background_violet.jpg": 536,
	"./task/common-healthcare/form_image.jpg": 499,
	"./task/common-healthcare/form_image_mobile.jpg": 523,
	"./task/common-healthcare/form_image_tablet.jpg": 524,
	"./task/common-healthcare/image_1.jpg": 537,
	"./task/common-healthcare/image_1_mobile.jpg": 538,
	"./task/common-healthcare/image_2.jpg": 554,
	"./task/common-healthcare/image_2_mobile.jpg": 555,
	"./task/common-healthcare/image_3.jpg": 681,
	"./task/common-healthcare/image_3_mobile.jpg": 682,
	"./task/common-healthcare/image_4.jpg": 556,
	"./task/common-healthcare/image_4_mobile.jpg": 557,
	"./task/common-healthcare/image_5.jpg": 683,
	"./task/common-healthcare/image_5_mobile.jpg": 684,
	"./task/common-healthcare/image_5_tablet.jpg": 685,
	"./task/common-healthcare/image_6.jpg": 686,
	"./task/common-healthcare/image_6_mobile.jpg": 687,
	"./task/common-healthcare/image_6_tablet.jpg": 688,
	"./task/common-healthcare/image_7.jpg": 689,
	"./task/common-healthcare/image_7_mobile.jpg": 690,
	"./task/common-healthcare/image_7_tablet.jpg": 691,
	"./task/common-healthcare/image_8.jpg": 558,
	"./task/common-healthcare/image_8_mobile.jpg": 559,
	"./task/education/devices_2_1920.jpg": 584,
	"./task/education/devices_2_375.jpg": 692,
	"./task/education/devices_2_768.jpg": 585,
	"./task/education/devices_3_1920.jpg": 586,
	"./task/education/devices_3_375.jpg": 693,
	"./task/education/devices_3_768.jpg": 587,
	"./task/education/form_1920.jpg": 544,
	"./task/education/tools_chats_1920.jpg": 588,
	"./task/education/tools_chats_768.jpg": 589,
	"./task/education/tools_meetings_1920.jpg": 590,
	"./task/education/tools_meetings_768.jpg": 591,
	"./task/education/who-is-suitable_1_1920.jpg": 592,
	"./task/education/who-is-suitable_2_1920.jpg": 593,
	"./task/education/who-is-suitable_3_1920.jpg": 594,
	"./task/healthcare/form-image.jpg": 560,
	"./task/healthcare/image.jpg": 694,
	"./task/healthcare/image_mobile.jpg": 695,
	"./task/healthcare/image_tablet.jpg": 696,
	"./task/healthcare/promo.jpg": 697,
	"./task/healthcare/promo_mobile.jpg": 698,
	"./task/healthcare/promo_tablet.jpg": 699,
	"./task/med/alternate_1.jpg": 700,
	"./task/med/alternate_1_mobile.jpg": 595,
	"./task/med/alternate_1_tablet.jpg": 701,
	"./task/med/alternate_2.jpg": 702,
	"./task/med/alternate_2_mobile.jpg": 596,
	"./task/med/alternate_2_tablet.jpg": 703,
	"./task/med/alternate_3.jpg": 704,
	"./task/med/alternate_3_mobile.jpg": 597,
	"./task/med/alternate_3_tablet.jpg": 705,
	"./task/med/promo.jpg": 706,
	"./task/med/promo_mobile.jpg": 707,
	"./task/nmo/image_1.jpg": 708,
	"./task/nmo/image_1_mobile.jpg": 709,
	"./task/nmo/image_3.jpg": 561,
	"./task/nmo/promo.jpg": 710,
	"./task/nmo/promo_mobile.jpg": 711,
	"./task/nmo/promo_tablet.jpg": 1112,
	"./task/ouz/image_1.jpg": 712,
	"./task/ouz/image_2.jpg": 713,
	"./task/ouz/image_3.jpg": 714,
	"./task/ouz/image_4.jpg": 715,
	"./task/ouz/image_5.jpg": 716,
	"./task/ouz/image_6.jpg": 717,
	"./task/ouz/image_6_mobile.jpg": 718,
	"./task/ouz/image_6_tablet.jpg": 719,
	"./task/ouz/promo.jpg": 720,
	"./task/ouz/promo_mobile.jpg": 721,
	"./task/pharma/image_1.jpg": 722,
	"./task/pharma/image_1_mobile.jpg": 723,
	"./task/pharma/image_2.jpg": 724,
	"./task/pharma/image_2_tablet.jpg": 725,
	"./task/pharma/image_3.jpg": 726,
	"./task/pharma/image_4.jpg": 727,
	"./task/pharma/image_5.jpg": 728,
	"./task/pharma/image_6.jpg": 729,
	"./task/pharma/image_6_mobile.jpg": 730,
	"./task/pharma/promo.jpg": 731,
	"./task/pharma/promo_mobile.jpg": 732,
	"./task/pharma/promo_tablet.jpg": 733,
	"./why-choose/why-choose-bg-900-735.jpg": 1113,
	"./why-choose/why-choose-bg.jpg": 1114,
	"./yaroslav_feshin.jpg": 1115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 477;